module.exports = __webpack_public_path__ + "images/talk-to-drawbotics-icon-abb69a8e5813214c20aa3f5c1dec196b.svg";